export default {
    namespaced: true,
    state: {
        show_menu: false,
        transition: false,
        calculatorDialog: false,
        profileDialog: false,
        lastRoute: ''
    },
    getters: {
        menuStatus: state => {
            return state.show_menu
        },
        transition: state => {
            return state.transition
        },
        calculatorDialog: state => {
            return state.calculatorDialog
        },
        profileDialog: state => {
            return state.profileDialog
        },
        lastRoute: state => {
            return state.lastRoute
        }
    },
    mutations: {
        SET_MENU: (state,payload) => {
            state.show_menu = payload
        },
        SET_TRANSITION: (state,payload) => {
            state.transition = payload
        },
        SET_CAL_DIALOG: (state, payload) => {
            state.calculatorDialog = payload
        },
        SET_PROFILE_DIALOG: (state, payload) => {
            state.profileDialog = payload
        },
        SET_LAST_ROUTE: (state, payload) => {
            state.lastRoute = payload
        }
    },
    actions: {
    }
}